"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthClient = exports.OauthProvider = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
var OauthProvider;
(function (OauthProvider) {
    OauthProvider["Adobe"] = "adobe";
    OauthProvider["Kameleoon"] = "kameleoon";
    OauthProvider["Slack"] = "slack";
    OauthProvider["Microsoft"] = "microsoft";
})(OauthProvider = exports.OauthProvider || (exports.OauthProvider = {}));
class OAuthClient extends authenticated_client_1.AuthenticatedClient {
    authorize(service, redirect, scopes) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = this.settings;
            const queryParamsObject = scopes ? { service, redirect, scopes } : { service, redirect };
            const queryParams = new URLSearchParams(queryParamsObject).toString();
            return `${config.url}/v1/oauth/authorize?${queryParams}`;
        });
    }
    exchangeAuthorizationCode(service, code) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/oauth/exchange/${service}`, { code });
            return response.payload;
        });
    }
}
exports.OAuthClient = OAuthClient;
//# sourceMappingURL=oauth.client.js.map